import React from "react";
import { selectIsWorkspaceEmpty, useWorkspaceContextStore } from "@presentation/stores/WorkspaceContextStore";
import { usePermissionStore } from "@presentation/stores/PermissionStore";
import { NoWorkspaceAccess } from "@presentation/components/workspace/NoWorkspaceAccess";
import { PermissionGate } from "@presentation/components/permission/PermissionGate";
import type { RouteItemProps } from "@presentation/common/RouteItemProps";

/**
A route with no `requiredPermission` is a default-context route and always renders unconditionally.
*/
export const PermissionGatedRoute: React.FC<{ route: RouteItemProps }> = ({ route }) => {
  const activeTeamId = useWorkspaceContextStore((state) => state.activeTeamId);
  const activeProjectId = useWorkspaceContextStore((state) => state.activeProjectId);

  const isWorkspaceEmpty = useWorkspaceContextStore(selectIsWorkspaceEmpty);
  const isAdmin = usePermissionStore((state) => state.isAdmin);

  if (isWorkspaceEmpty && !isAdmin && !route.allowWithoutWorkspace) return <NoWorkspaceAccess />;
  if (!route.requiredPermission) return route.element ?? null;
  return (
    <PermissionGate requirement={route.requiredPermission} teamId={activeTeamId} projectId={activeProjectId}>
      {route.element ?? null}
    </PermissionGate>
  );
};
